import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./StudentListItem.module.css";
import StatusButton from "components/StatusButton";
import { BackgroundCheckTypes, WatchCheckTypes } from "pages/enums";
import { formatDateOnlyInUtc } from '../../../utils/helpers';

const StudentListItem = ({
  student,
  onCheckboxChange,
  onStatusChange,
  onWatchReportSubmitClick,
  onStudentNameClick,
  view
}) => {

  const triggerCallback = () => {
    onWatchReportSubmitClick(student);
  }

  const triggerNameClickCallback = () => {
    onStudentNameClick(student);
  }

  if (view === "cpnw") {
    return (
      <div className={`${styles.container} ${styles.cpnwContainer}`}>
        <div className={styles.cpnwNameColumn}>
          <span className={styles.studentNameText} onClick={triggerNameClickCallback}>{student.name}</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span>{student.middleInitial}</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span>{formatDateOnlyInUtc(student.dob)}</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span>{student.program}</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span>{student.school}</span>
        </div>
        {student.WatchCheckTypeStatusId === 2 &&
          <div className={styles.cpnwColumn}>
            <button className={styles.submitButton} onClick={triggerCallback}>
              Submit
            </button>
          </div>
        }
        {(student.WatchCheckTypeStatusId === 4 || student.WatchCheckTypeStatusId === 3 || student.WatchCheckTypeStatusId === 5) &&
          <div className={styles.cpnwColumn}>
            <button className={styles.submittedButton}>
              WATCH Report Submitted
            </button>
          </div>
        }
      </div>
    );
  } else {
    return (
      <div className={styles.container}>
        <div className={styles.checkboxContainer}>
          <input
            type="checkbox"
            className={`${styles.checkbox} ${student.isSelected ? styles.checked : ""}`}
            onChange={() => onCheckboxChange(student, "isSelected")}
            checked={student.isSelected}
            disabled={student.checkboxDisabled}
          />
        </div>

        <div className={styles.studentNameContainer}>
          <span className={styles.studentNameText} onClick={triggerNameClickCallback}>{student.name}</span>
        </div>

        <div className={styles.radioButtonContainer}>
          <input
            type="checkbox"
            className={`${styles.radioButton} ${student.isCheckr ? styles.checked : ""
              }`}
            onChange={() => onCheckboxChange(student, "isCheckr")}
            checked={student.isCheckr || student.checkrDisabled}
            disabled={student.backgroundCheckTypeId != BackgroundCheckTypes.Checkr || student.checkrDisabled}
            title={student.backgroundCheckTypeId != BackgroundCheckTypes.Checkr ? "This option is not Enabled for the student's program" : ""}
          />
        </div>

        <div className={styles.statusContainer}>
          <span className={null}>{student.backgroundCheckSubmittedOn}</span>
        </div>

        <div className={styles.statusContainer}>
          {/* Initiate */}
          {!student.checkrDisabled && student.watchDisabled && <StatusButton onClick={() => {
            if(student.isCheckr) {
              onStatusChange(student)
            }
          }}
            status={student.isCheckr ? 'initiate' : 'na'}
            disabled={student.status == 'na'}
          />}

          {/* Resend Checkr */}
          {student.checkrDisabled && <StatusButton onClick={() => {
            onStatusChange(student, "resend", "checkr")
          }}
            status={student.status}
            keepResend={true}
          />
          }
        </div>

        <div className={styles.radioButtonContainer}>
          <input
            type="checkbox"
            className={`${styles.radioButton} ${student.isCPNW ? styles.checked : ""
              }`}
            onChange={() => onCheckboxChange(student, "isCPNW")}
            checked={student.isCPNW || student.watchDisabled}
            disabled={student.watchCheckTypeId != WatchCheckTypes.CPNW || student.watchDisabled}
            title={student.watchCheckTypeId != WatchCheckTypes.CPNW ? "This option is not Enabled for the student's program" : ""}
          />
        </div>

        <div className={styles.statusContainer}>
          <span className={null}>{student.watchCheckSubmittedOn}</span>
        </div>

        <div className={styles.statusContainer}>
          {/* Initiate */}
          {!student.checkrDisabled && !student.watchDisabled && <StatusButton onClick={() => {
            if (student.isCPNW || student.isCheckr) {
              onStatusChange(student)
            }
          }}
            status={student.status}
            disabled={student.status == 'na'}
          />}

          {/* Initiate for CPNW only */}
          {student.checkrDisabled && !student.watchDisabled && <StatusButton onClick={() => {
            if(student.isCPNW) {
              onStatusChange(student)
            }
          }}
            status={student.isCPNW ? 'initiate' : 'na'}
            disabled={student.status == 'na'}
          />}

          {/* Resend CPNW */}
          {student.watchDisabled && <StatusButton onClick={() => {
            onStatusChange(student, "resend", "cpnw")
          }
          }
            status={student.status}
            keepResend={true}
          />}
        </div>
      </div>
    );
  }

};

StudentListItem.propTypes = {
  student: PropTypes.object.isRequired,
  onCheckboxChange: PropTypes.func,
  onStatusChange: PropTypes.func,
  onWatchReportSubmitClick: PropTypes.func,
  onStudentNameClick: PropTypes.func,
  view: PropTypes.oneOf(["background", "cpnw"]),
};

export default StudentListItem;